import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import cx from 'classnames'

import { TickIcon } from 'images/icons'

const AboutCultureListItem = ({ title }) => {
  const listItemRef = useRef(null)
  const [isInView, setIsInView] = useState(false)

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)
    gsap.timeline({
      scrollTrigger: {
        trigger: listItemRef.current,
        start: 'top 80%',
        end: 'bottom 20%',
        onEnter: () => {
          if (!isInView) {
            setIsInView(true)
          }
        },
      },
    })
  }, [])

  return (
    <li
      ref={listItemRef}
      className={cx({
        '--in-view': isInView,
      })}
    >
      <div className="culture-bullet">
        <p>{title}</p>
        <TickIcon />
      </div>
    </li>
  )
}

AboutCultureListItem.propTypes = {
  title: PropTypes.string,
}

export default AboutCultureListItem
